import React, { useState } from 'react';
import { Input, Select, Modal } from 'antd';
import styles from './add-lead.module.scss';
import { useSelector } from 'react-redux';
import { toggleNewLead } from 'redux/spot/spot-actions';

const { Option } = Select;

export const AddLeadForm = () => {
  const { isNewLeadOpen } = useSelector((state) => state.spot);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    grade: 'K',
    status: 'new',
  });
  const handleChange = (field, value) => {};

  return (
    <Modal title="New Lead" open={isNewLeadOpen} onCancel={toggleNewLead} footer={null}>
      <div className={styles.formContainer}>
        <div className={styles.formRow}>
          <label htmlFor="name" className={styles.formLabel}>
            Parent Name *
          </label>
          <Input
            id="name"
            value={formData.name}
            onChange={(e) => handleChange('name', e.target.value)}
            className={styles.formInput}
          />
        </div>
        <div className={styles.formRow}>
          <label htmlFor="email" className={styles.formLabel}>
            Email *
          </label>
          <Input
            id="email"
            type="email"
            value={formData.email}
            onChange={(e) => handleChange('email', e.target.value)}
            className={styles.formInput}
          />
        </div>
        <div className={styles.formRow}>
          <label htmlFor="phone" className={styles.formLabel}>
            Phone *
          </label>
          <Input
            id="phone"
            value={formData.phone}
            onChange={(e) => handleChange('phone', e.target.value)}
            className={styles.formInput}
          />
        </div>
        <div className={styles.formRow}>
          <label htmlFor="grade" className={styles.formLabel}>
            Student Grade
          </label>
          <Select
            value={formData.grade}
            onChange={(value) => handleChange('grade', value)}
            className={styles.formInput}
            placeholder="Select grade">
            <Option value="K">Kindergarten</Option>
            <Option value="1">1st Grade</Option>
            <Option value="2">2nd Grade</Option>
            <Option value="3">3rd Grade</Option>
            <Option value="4">4th Grade</Option>
            <Option value="5">5th Grade</Option>
            <Option value="6">6th Grade</Option>
            <Option value="7">7th Grade</Option>
            <Option value="8">8th Grade</Option>
            <Option value="9">9th Grade</Option>
            <Option value="10">10th Grade</Option>
            <Option value="11">11th Grade</Option>
            <Option value="12">12th Grade</Option>
          </Select>
        </div>
        <div className={styles.formRow}>
          <label htmlFor="status" className={styles.formLabel}>
            Status
          </label>
          <Select
            value={formData.status}
            onChange={(value) => handleChange('status', value)}
            className={styles.formInput}
            placeholder="Select status">
            <Option value="new">New</Option>
            <Option value="attempting">Attempting Contact</Option>
            <Option value="working">Working</Option>
          </Select>
        </div>
      </div>
    </Modal>
  );
};
